type JsonLd = Record<string, unknown>;

export type SeoProps = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  image?: string;
  type?: string;
  modifiedTime?: string;
  jsonLd?: JsonLd | JsonLd[];
};

const SITE_NAME = "深瓜社";

const buildCanonical = (path: string) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "https://shenguashe.example.com";
  const base = typeof __BASE_PATH__ === "string" ? __BASE_PATH__ : "/";
  const cleanBase = base.endsWith("/") ? base.slice(0, -1) : base;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${origin}${cleanBase}${cleanPath === "/" ? "/" : cleanPath}`;
};

export default function Seo({
  title,
  description,
  keywords,
  path,
  image,
  type = "website",
  modifiedTime,
  jsonLd,
}: SeoProps) {
  const canonical = buildCanonical(path);
  const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image ? <meta name="twitter:image" content={image} /> : null}
      {modifiedTime ? <meta property="article:modified_time" content={modifiedTime} /> : null}
      {jsonLdList.map((item, index) => (
        <script
          key={`ld-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}